<!--
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2021-11-22 14:02:30
 * @LastEditors: ankeji
 * @LastEditTime: 2021-11-22 14:18:30
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    if(window.location.host === 'medilink-global.cn') {
      location.href = 'https://medilink-global.com.cn/MediLink/index'
    }
  }
}
</script>
<style lang="less">
#app {
  min-width: 1440px;
  overflow-x: auto;
}
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
html {
  overflow-x: hidden;
}
</style>
